<div style="font-size: 12px;">
  <div class="panel-body">

    <!--ROW 1: CUSTOMER NAME & CONTACT NAME  -->
    <div class="row">
      <div class="col-sm">
        <div class="row">
          <label class="tenant-info-title">CUSTOMER NAME</label>
          <p class="paragraph-text">{{details?.customer?.company_name}}</p>
        </div>
      </div>
      <div class="col-sm">
        <div class="row">
          <label class="tenant-info-title">CONTACT NAME</label>
          <p class="paragraph-text">{{details?.customer?.first_name}} {{details?.customer?.last_name}}</p>
        </div>
      </div>
    </div>

    <!--ROW 2: CUSTOMER ID & ADDRESS  -->
    <div class="row">
      <div class="col-sm">
        <div class="row">
          <label class="tenant-info-title">CUSTOMER ID</label>
          <p class="paragraph-text">{{details?.customer?.customer_id}}</p>
        </div>
      </div>
      <div class="col-sm">
        <div class="row">
          <label class="tenant-info-title">ADDRESS</label>
          <p class="paragraph-text" class="paragraph-text">{{details?.customer?.address_1}} {{
            details?.customer?.address_2}} {{ details?.customer?.address_3}} {{
            details?.customer?.city}}, {{details?.customer?.region}} {{
            details?.customer?.post_code}}
          </p>
        </div>
      </div>
    </div>

    <!--ROW 3: MARKET SEGMENT & PHONE  -->
    <div class="row">
      <div class="col-sm">
        <div class="row">
          <label class="tenant-info-title">MARKET SEGMENT</label>
          <div [ngSwitch]="details?.customer?.market_segment">
            <ng-template [ngSwitchCase]="'COM'">
              <p class="paragraph-text">COMMERCIAL</p>
            </ng-template>
            <ng-template [ngSwitchCase]="'EDU'">
              <p class="paragraph-text">EDUCATION</p>
            </ng-template>
            <ng-template [ngSwitchCase]="'GOV'">
              <p class="paragraph-text">GOVERNMENT</p>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="row">
          <label class="tenant-info-title">PHONE</label>
          <p class="paragraph-text">{{ details?.customer?.phone }}</p>
        </div>
      </div>
    </div>

    <!--ROW 4: ______   & EMAIL  -->
    <div class="row">
      <div class="col-sm">

      </div>
      <div class="col-sm">
        <div class="row">
          <label class="tenant-info-title">EMAIL</label>
          <p class="paragraph-text">{{ details?.customer?.email }}</p>
        </div>
      </div>
    </div>

    <!--ROW 5: ANNIVERSARY DATE & 3 YEAR COMMIT STATUS  -->
    <div class="row">
      <div class="col-sm">
        <div class="row" *ngIf="details?.customer?.is_coterm">
          <label class="tenant-info-title">ANNIVERSARY DATE</label>
          <div [ngSwitch]="details?.customer?.market_segment">
            <p class="paragraph-text">{{ details?.customer?.coterm_date | date: 'dd/MM/yyyy'}}</p>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="row" *ngIf="show3YCStatus()">
          <label class="tenant-info-title">3 YEAR COMMIT STATUS</label>
          <p class="paragraph-text">{{ details?.customer?.three_year_commitment_status }}</p>
          <mat-icon matSuffix
            class="editmpnidicon"
            style="font-size: 14px; line-height: unset; margin-left: 10px;"
            [matTooltipPosition]="'right'"
            matTooltip="Customer needs to accept the 3YC invitation to qualify for 3YC pricing"
          >info</mat-icon>
        </div>
      </div>
    </div>

    <!--ROW 4: DISCOUNT LEVEL  & 3 YEAR COMMIT  -->
    <div class="row">
      <div class="col-sm">
        <div class="row">
          <label class="tenant-info-title">DISCOUNT LEVEL</label>
          <ul class="no-bullets">
            <li class="row" style="margin-left: unset;">
              <p class="lable-title" style="width: 100px; margin-bottom: unset;">License</p>
              <p class="paragraph-text" style="margin-bottom: unset;">{{ details?.customer?.license_discount_level }}</p>
            </li>
            <li class="row" style="margin-left: unset;">
              <p class="lable-title" style="width: 100px;">Consumables</p>
              <p class="paragraph-text">{{ details?.customer?.consumables_discount_level }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm">
        <div class="row" *ngIf="details?.customer?.number_of_license_commitments">
          <label class="tenant-info-title">3 YEAR COMMIT</label>
          <ul class="no-bullets">
            <li class="row" style="margin-left: unset;" *ngIf="details?.customer?.number_of_license_commitments">
              <p class="lable-title" style="width: 200px; margin-bottom: unset;">No. of License Commitments</p>
              <!-- <p class="paragraph-text" style="margin-bottom: unset;"> -->
                <!-- <container-element [ngSwitch]="details?.customer?.number_of_license_commitments"> -->
                  <p class="paragraph-text" style="margin-bottom: unset;">{{details?.customer?.number_of_license_commitments}}</p>
                  <!-- <p *ngSwitchCase="10" class="paragraph-text" style="margin-bottom: unset;">10</p> -->
                  <!-- <p *ngSwitchCase="50" class="paragraph-text" style="margin-bottom: unset;">50</p>
                  <p *ngSwitchCase="100" class="paragraph-text" style="margin-bottom: unset;">100</p> -->
                <!-- </container-element> -->
              <!-- </p> -->
            </li>
            <li class="row" style="margin-left: unset;" *ngIf="details?.customer?.three_year_commitment_start_date">
              <p class="lable-title" style="width: 150px; margin-bottom: unset;">Commit Start Date</p>
              <p class="paragraph-text" style="margin-bottom: unset;">{{ details?.customer?.three_year_commitment_start_date | date: 'dd-MM-yyyy' }}</p>
            </li>
            <li class="row" style="margin-left: unset;" *ngIf="details?.customer?.three_year_commitment_end_date">
              <p class="lable-title" style="width: 150px;">Commit Expiry Date</p>
              <p class="paragraph-text">{{ details?.customer?.three_year_commitment_end_date | date: 'dd-MM-yyyy' }}</p>
            </li>
            <!-- <li class="row" style="margin-left: unset;" *ngIf="details?.customer?.number_of_consumables_commitments">
              <p class="lable-title" style="width: 200px;">No. of Consumables Commitments</p>
              <p class="paragraph-text">{{ details?.customer?.number_of_consumables_commitments }}</p>
            </li> -->
          </ul>
          <!-- <label class="tenant-info-title">3 YEAR COMMIT START</label>
          <ul class="no-bullets">
            <li class="row" style="margin-left: unset;">
              <p class="paragraph-text">{{ (details?.customer?.three_year_commitment_start_date | date: 'dd/MM/yyyy') || 'ss/ss/ss'}}</p>                 
            </li>
          </ul>
          <label class="tenant-info-title">3 YEAR COMMIT EXPIRY</label>
          <ul class="no-bullets">
            <li class="row" style="margin-left: unset;">
              <p class="paragraph-text">{{ details?.customer?.three_year_commitment_end_date | date: 'dd/MM/yyyy'}}</p>                 
            </li>
          </ul> -->
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-4">
        <button
          [disabled]="!authService?.currentUserHasPurchaseAccess()"
          [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
          matTooltip="Requires Purchasing Permissions"
          class="button button-red button-mid edit-enduser"
          (click)="editEndUserDetail($event)">Edit Customer</button>
      </div>
    </div>

    <ng-container *ngIf="paymentMethod">



      <!-- Paymen Detail Section-->
      <div class="row">
        <div class="col-sm">
          <div class="flex-item agreement-margin"><span class="highlight-text">PAYMENT DETAILS</span>
            <div class="basic-icon">
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-sm">
          <div class="row">
            <label class="tenant-info-title">PAYMENT TYPE</label>
            <p class="paragraph-text">{{paymentMethod?.out_payment_method }}</p>
          </div>
        </div>
        <div class="col-sm">

        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <div class="row">
            <label class="tenant-info-title">DESCRIPTION</label>
            <p class="paragraph-text">{{ paymentMethod?.out_account_name + paymentMethod?.out_masked_card_number }}</p>
          </div>
        </div>
        <div class="col-sm">

        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <div class="row">
            <label class="tenant-info-title">ID</label>
            <p class="paragraph-text">{{paymentMethod?.out_customer_number }}</p>
          </div>
        </div>
        <div class="col-sm">

        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <div class="row">
            <label class="tenant-info-title">EXPIRY</label>
            <p class="paragraph-text">{{paymentMethod?.out_expiry  }}</p>
          </div>
        </div>
        <div class="col-sm">

        </div>
      </div>

      <div>
        <div class="col-sm" style="padding-left: unset;">
          <button
            [disabled]="!authService?.currentUserHasPurchaseAccess()"
            [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
            matTooltip="Requires Purchasing Permissions"
            (click)="editPaymentDetails($event)"
            class="button button-red button-mid edit-enduser">
            Edit Payment Details</button>
          <br />
          <br />
        </div>

      </div>
    </ng-container>

  </div>
</div>